module.exports = __webpack_public_path__ + "static/media/download.d9a6c870.svg";